import { useTranslation } from 'react-i18next';

import CopyFill from '@/assets/icons/copy_fill.svg?component';
import Share2Line from '@/assets/icons/share_2_line.svg?component';
import { Button } from '@/components/atoms/Buttons';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import TextField from '@/components/atoms/TextField';
import DropDownPanel from '@/components/molecules/DropDownPanel';

import styles from './ShareImage.module.scss';

const SHARE_BUTTON_NAME = 'share';

export interface ShareImageProps {
    permalink?: string;
    scpCommand?: string;
    isOptoScaleAdmin?: boolean;
}

export default function ShareImage(props: ShareImageProps) {
    const { permalink = '', scpCommand = '', isOptoScaleAdmin = false } = props;

    const { t } = useTranslation();

    const copyToClipboardHandler = (text: string) => {
        navigator.clipboard.writeText(text).then(
            () => {
                console.log('Copied to clipboard');
            },
            (err) => {
                console.error('Failed to copy to clipboard', err);
            }
        );
    };

    return (
        <DropDownPanel
            label={t('organisms.imageViewer.copyImageUrlToThis')}
            trackingId="image_viewer_share_open"
            variant="toolbar"
            name={SHARE_BUTTON_NAME}
            icon={<SvgIcon color="currentColor" icon={Share2Line} />}
            className={styles.shareImagePanel}>
            <fieldset className={styles.shareImage_content}>
                <legend>{t('organisms.imageViewer.copyImageUrlToThis')}</legend>
                <div data-type="formrow">
                    <TextField
                        type="text"
                        value={permalink}
                        readOnly
                        onClick={(e) => {
                            e.currentTarget.select();
                        }}
                    />
                    <Button
                        variant="secondary"
                        trackingId="image_viewer_share_copy_url"
                        onClick={() => {
                            copyToClipboardHandler(permalink);
                        }}
                        icon={<SvgIcon color="currentColor" icon={CopyFill} />}>
                        {t('common.actions.copy')}
                    </Button>
                </div>
            </fieldset>
            {isOptoScaleAdmin && scpCommand.length > 0 && (
                <fieldset className={styles.shareImage_content}>
                    <legend>{t('organisms.imageViewer.copyScpCommandForImage')}</legend>
                    <div data-type="formrow">
                        <TextField
                            type="text"
                            value={scpCommand}
                            readOnly
                            onClick={(e) => {
                                e.currentTarget.select();
                            }}
                        />
                        <Button
                            variant="secondary"
                            trackingId="image_viewer_share_copy_scp"
                            onClick={() => {
                                copyToClipboardHandler(scpCommand);
                            }}
                            icon={<SvgIcon color="currentColor" icon={CopyFill} />}>
                            {t('common.actions.copy')}
                        </Button>
                    </div>
                </fieldset>
            )}
        </DropDownPanel>
    );
}
